import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { HOME_PAGE_MAKER_COUNT } from "@faire/web-api--source/indigofair/settings/HOME_PAGE_MAKER_COUNT";

export const getSettingTotalBrandCount = (): number =>
  getSettingValueWithoutAssignment(HOME_PAGE_MAKER_COUNT, 7000);
